import { LatLng, LatLngLiteral } from 'leaflet';
import { IMapSettings } from 'views/components/Video/MapComponent';

export const recordPage = 14;
export const mapSettings: IMapSettings = {
  center: new LatLng(59.953551884820094, 30.30990600585938),
  zoom: 11,
  layers: {
    routes: true,
    stops: true,
    vehicles: true,
    dep: true,
    dep_point: true
  },
  showDrawPanel: false,
  bounds: null,
};
